export const COMPANION_APP_STORE_LINKS = {
    /**
     * The public App Store listing. This was a TestFlight invite while the build
     * sat in App Review, because a store URL for an unapproved app 404s for the
     * member; the app was approved on 2026-08-19. Deployments can still override
     * via EMAIL_IOS_APP_URL without waiting for a web release.
     *
     * The `/us/` segment pins the US storefront. Apple redirects a member browsing
     * from another region, so this resolves outside the US, but the locale-free
     * `https://apps.apple.com/app/id6775635574` is the form to switch to if a
     * non-US storefront ever reports otherwise.
     */
    ios: "https://apps.apple.com/us/app/thrive-healthos/id6775635574",
    android: "https://play.google.com/store/apps/details?id=com.thriveglobal.healthos.mobile",
};
//# sourceMappingURL=companion-app.js.map